<script setup lang="ts">
</script>

<template>
  <div class="copyright">
    <div class="container">
      <div class="copyright py-6 text-center">
        <p class="text-xs sm:text-sm" v-html="$t('footer.copyrightText')"></p>
        <p class="text-xs sm:text-sm">{{ $t("footer.taxInformation") }}</p>
      </div>
    </div>
  </div>
</template>